import { render, staticRenderFns } from "./ProjectRewriteComponent.vue?vue&type=template&id=2fb05c1a&scoped=true&"
import script from "./ProjectRewriteComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectRewriteComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRewriteComponent.vue?vue&type=style&index=0&id=2fb05c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb05c1a",
  null
  
)

export default component.exports